const Loading = () => {
  return (
    <div className="flex items-center justify-center space-x-2 bg-slate-700 w-sreen h-screen">
      <div className="w-8 h-8 rounded-full animate-pulse bg-slate-400"></div>
      <div className="w-8 h-8 rounded-full animate-pulse bg-slate-500"></div>
      <div className="w-8 h-8 rounded-full animate-pulse bg-slate-400"></div>
    </div>
  );
};

export default Loading;
